/**
 * 格式化会议号为易读的间隔格式，
 * <9位的时候，前端会议号展示为123 456 78
    9位的时候，前端会议号展示为123 456 789
   10位的时候，前端会议号展示为123 456 7891
   11位的时候，前端会议号展示为123 4567 8912
   12位的时候，前端会议号展示为1234 5678 9012
 * @param {会议号} code
 */
export function formatMeetingCode(meetingCode: string | number): string {
  let code = `${meetingCode}`;
  if (!/^[\d\s]+$/.test(code)) {
    return '';
  }

  code = code.replace(/\s/g, '');

  let res = '';
  if (code.length < 10) {
    res = code.replace(/(\d{3})(?=\d)/g, '$1 ');
    return res;
  }

  switch (code.length) {
    case 10:
      res = `${code.substr(0, 3)} ${code.substr(3, 3)} ${code.substr(6, 4)}`;
      break;
    case 11:
      res = `${code.substr(0, 3)} ${code.substr(3, 4)} ${code.substr(7, 4)}`;
      break;
    case 12:
      res = `${code.substr(0, 4)} ${code.substr(4, 4)} ${code.substr(8, 4)}`;
      break;
    default:
      res = code;
  }

  return res;
}
